<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="title">3天CP·爱在进行时</div>
      <div class="declaration">
        人生海海<br>总会有一个人会成为你的信徒<br>穿越茫茫人海与你一见如故<br>
        陪你见证宇宙山河浪漫，人间点滴温暖<br>在这里，开启你的邂逅之旅吧
      </div> -->
      <!-- <img class="pic-title" src="https://static.huiyiji520.com/cppic-1661943120.png">
      <img class="pic-declaration" src="https://static.huiyiji520.com/cppic-1661823673.png"> -->
      <div class="unpay" v-if="pay != 'yes'">
        <div class="title">支付10元定金，即可预约</div>
        <div class="btn-me flex-box" @click="submitPay()">支付并预约</div>
      </div>

      <div class="paid" v-if="pay == 'yes'">
        <div class="title">已预约，请扫码添加红娘微信</div>
        <img class="qrcode" :src="broker_qrcode">
      </div>

    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { Toast, Dialog } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },
  data(){
    return {
      openid: "",
      pay: "",
      broker_qrcode: ""
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    submitPay(){
      let openid = this.$store.state.userinfo.openid
      this.$api.post('/appoint/pay_h5', { openid: openid }, res => {
       if(res.code == 200){
         // console.log('res :' + res)
         let _this = this
         wx.chooseWXPay({
           timestamp: res.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
           nonceStr: res.nonceStr, // 支付签名随机串，不长于 32 位
           package: res.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
           signType: res.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
           paySign: res.paySign, // 支付签名
           success: function (payRes) {
             // 支付成功后的回调函数
             // alert("pay success: " + JSON.stringify(payRes));
             _this.pay = "yes"
             _this.broker_qrcode = res.broker_qrcode
           },
           fail: function (payErr){
             // alert("pay fail: " + JSON.stringify(payErr));
             // alert("pay res: " + JSON.stringify(res))
           }
         })
       }else{
         Toast(res.msg)
       }
     })
    },
    getPayStatus(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/appoint/get_pay_status', {openid: openid}, res => {
        if(res.code == 200){
          this.pay = res.pay
          this.broker_qrcode = res.broker_qrcode
        }
      })
    },
    wxConfigInit(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/couple/get_wx_js_config_couple', {url: window.location.href, openid: openid}, res => {
        if(res.code == 200 && res.config){
          // alert('config: ' +JSON.stringify(res.config))
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.config.app_id, // 必填，公众号的唯一标识
            timestamp: res.config.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.config.noncestr, // 必填，生成签名的随机串
            signature: res.config.signature,// 必填，签名
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
          });
        }
      })
    }
  },
  mounted(){
    this.wxConfigInit()
    this.getPayStatus()
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  /* background-image: url("https://static.huiyiji520.com/cponline-1659166921.jpg"); */
  /* background-image: url("https://static.huiyiji520.com/bg-1661137902.png"); */
  background-image: url("https://static.huiyiji520.com/cppic-1661150074.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;padding-top:40%;}
/* .main .title{margin-top:200px;margin-bottom:113px;font-size:70px;color:#eb8e80;font-weight:bold;font-family:'NotoSerifSCBlack';}
.main .declaration{font-size:40px;line-height:80px;color:#737373;margin-bottom:113px;} */
.btn-me{
  width:342px;height:90px;font-size:40px;border:5px solid #0f88eb;border-radius:15px;
  margin:0px auto;color:#ffffff;background:#0f88eb;justify-content:center;
}
/* position:fixed;bottom:200px;left:0;right:0; */
.main .pic-title{width:202px;height:65px;margin:0 auto;margin-top:207px;margin-bottom:170px;}
.main .pic-declaration{width:704px;height:445px;margin:0 auto;margin-bottom:150px;}
.main .unpay .title{font-size:50px;font-weight:bold;margin-bottom:100px;}
.main .paid .title{font-size:50px;font-weight:bold;margin-bottom:100px;}
.main .paid .qrcode{width:300px;display:block;margin:0 auto;}
</style>
